import { List, Tooltip } from 'antd';
import React from 'react';
import { ObterComentarioPorItemId } from '@app/api/minuta/ItemClausula';
import { usePromise, Button, Icon } from '@digital/ui';
import { convertUTCtoLocal } from '@app/helpers/dateTimeFormats';
import moment from 'moment';


interface ListMensagemClausulaProps {
  itemId: string,
  recarregarMensagem: boolean;
}

export default function ListMensagemClausula({ itemId, recarregarMensagem }: ListMensagemClausulaProps) {

  const [getAllMensagem] = usePromise(
    () =>
      itemId
        ? ObterComentarioPorItemId(itemId)
        : Promise.resolve(undefined),
    [itemId, recarregarMensagem],
    [],
  );

  return (
    <div>
      <List
        itemLayout="horizontal"
        dataSource={getAllMensagem}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              title={
                <a href="#">
                  {item.nomeDoUsuario + ' - ' + convertUTCtoLocal(moment(item.dataHoraInclusao, "DD/MM/YYYY HH:mm:ss")).toLocaleString()}
                </a>
              }
              description={item.mensagem}
              className={item.mrn ? 'classeMrn' : 'classeFornecedor'}
            />
          </List.Item>
        )}
      />
    </div>
  );
}
